import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs';
import { Storage } from '@ionic/storage';
import { RequestService } from './request.service';
import { Router } from '@angular/router';
import { WebSocketService } from './web-socket.service';
import { UtilitiesService } from './utilities.service';
import { EncryptionService } from './encryption.service';

const TOKEN_KEY = 'auth-token';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  authenticationState = new BehaviorSubject(false);
  userType:string;

  constructor(private storage: Storage, private encryptation:EncryptionService, private plt: Platform, private request: RequestService, private router:Router, private utilities: UtilitiesService) {
  }

  async checkToken(): Promise<boolean> {
    try {
      // console.info("OK");
      const res = await this.storage.get(TOKEN_KEY);
      if (res) {
        const resDecript = this.encryptation.decryptStringa(res);
        this.request.token = resDecript;
        
        // Wrap la risposta in una Promise
        return new Promise<boolean>((resolve) => {
          this.request.get({
            path: "/checkToken",
            handler: (response) => {
              this.authenticationState.next(true);
              resolve(true);
            },
            error: (error) => {
              this.authenticationState.next(false);
              resolve(false); // Se c'è un errore, rifiuta la Promise
            }
          });
        });
      } else {
        this.authenticationState.next(false);
        return Promise.resolve(false);  // Restituisce una Promise risolta come false
      }
    } catch (error) {
      this.authenticationState.next(false);
      return Promise.resolve(false);
    }
  }

  async login(response: any) {
    // console.info(response);
    this.request.token=response["access_token"];
    const tokenEncrypt = this.encryptation.encryptStringa(response["access_token"]);
    await this.storage.set(TOKEN_KEY, tokenEncrypt);
    const deviceEncrypt = this.encryptation.encryptStringa(response["device_id"]);
    await this.storage.set("device_id", deviceEncrypt);
    const utenteEncrypt = this.encryptation.encryptStringa(JSON.stringify(response["_infoUtente"]));
    await this.storage.set("utenteJson", utenteEncrypt);
    const foto = response["_foto"];
    // console.info(foto[0]);
    if (foto && foto.length > 0) {
      // this.userPic = 'http://localhost:5000/' + foto[0]["path"] + foto[0]["file.id"] + ".jpg";
      const foto1 = 'https://andron.fdcmessina.org/' + foto[0]["path"] + foto[0]["nome"];
      const fotoEncrypt = this.encryptation.encryptStringa(foto1);
      await this.storage.set("foto", fotoEncrypt);
      // console.info(this.userPic);
    } else {
      const foto1 = this.utilities.user;  // Usa una foto di default
      const fotoEncrypt = this.encryptation.encryptStringa(foto1);
      await this.storage.set("foto", fotoEncrypt);
    }
    if (response["_publicKey"] == null) {
      
    }
    else{
      const publicKeyEncrypt = this.encryptation.encryptStringa(response["_publicKey"]);
      await this.storage.set("publicKey", publicKeyEncrypt);
    }
    if (response["_privateRecoveryKey"] == null) {
      
    }
    else{
      const privateKeyEncrypt = this.encryptation.encryptStringa(response["_privateRecoveryKey"]);
      await this.storage.set("privateRecoveryKey", privateKeyEncrypt);
    }

    this.authenticationState.next(true);
  }

  logout() {
    this.storage.remove("utenteJson") && this.storage.remove("foto") && this.storage.remove(TOKEN_KEY) && this.storage.remove("device_id") && this.storage.remove("publicKey") && this.storage.remove("privateRecoveryKey") && this.storage.remove("psw");
    // this.storage.clear();
    window.localStorage.clear();
    window.sessionStorage.clear();
    this.authenticationState.next(false);
    // this.router.navigate(["login"]);
  }

  async isAuthenticated(): Promise<boolean> {
    // Chiama checkToken() e aspetta che venga completato
    const isAuth = await this.checkToken();
    // console.log('Is authenticated:', isAuth);  // Puoi aggiungere log per verificare il risultato
    return isAuth;  // Restituisce il risultato booleano
  }

}
